import { createApi } from "@reduxjs/toolkit/query/react";
import { fetchBaseQueryByAxios } from "@/redux/api/fetchBaseQueryHelper";
import _ from "lodash";

/**
 * https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery#prepareheaders
 * here to learn more about the query
 * or see
 * `postSlice-example`, `userSlice-example`
 */
export const driverApi = createApi({
	reducerPath: "driver",
	baseQuery: fetchBaseQueryByAxios,
	endpoints: (builder) => ({
		getDrivers: builder.query({
			query: () => `/userDetail/queryUserDetailByRole?role_id=3`,
			transformResponse: (responseData) => {
				return responseData.data;
			},
		}),
		deleteDriver: builder.mutation({
			query(id) {
				return {
					url: `/userDetail/deleteUserDetailById?user_detail_id=${id}`,
					method: "DELETE",
				};
			},
		}),
		addDriver: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/userDetail/insertUserDetail",
					method: "POST",
					body: initialPost,
				};
			},
		}),
		updateDriver: builder.mutation({
			query: (initialPost) => {
				return {
					url: "/userDetail/updateUserDetailById",
					method: "PUT",
					body: initialPost,
				};
			},
		}),
		getDriverByProductAndDate: builder.query({
			query: ({ productId, travelDate }) =>
				`userDetail/queryDriverDataWithDate?product_id=${productId}&travel_date=${travelDate}`,
		}),
	}),
});

export const {
	useGetDriversQuery,
	useAddDriverMutation,
	useDeleteDriverMutation,
	useUpdateDriverMutation,
	useGetDriverByProductAndDateQuery,
} = driverApi;
